<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">评分管理</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="创建时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="editScoreDialog(-1)">新建评分</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            border
        >
          <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1" ></el-table-column>
          <el-table-column property="" label="性别" v-if="checkColList.indexOf('性别') > -1">
            <template #default="scope">
              {{scope.row.sex == 0?'通用':scope.row.sex == 1?'男':scope.row.sex == 2?'女':''}}
            </template>
          </el-table-column>
          <el-table-column property="score" label="分数" v-if="checkColList.indexOf('分数') > -1"></el-table-column>
          <el-table-column property="msg" label="评语" v-if="checkColList.indexOf('评语') > -1"></el-table-column>
          <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              {{scope.row.state == 1?'待启用':scope.row.state == 2?'已启用':scope.row.state == 3?'已停用':''}}
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
              <el-space wrap>
                <el-button size="small" @click="editScoreDialog(scope.$index,scope.row)" type="primary">编辑</el-button>
                <el-button size="small" v-loading="scope.row['updateLoading']" type="success" v-show="scope.row.state == 1 || scope.row.state == 3" @click="updateState(scope.$index, scope.row, 2)">启用</el-button>
                <el-button size="small" v-loading="scope.row['updateLoading']" type="warning" v-show="scope.row.state == 2" @click="updateState(scope.$index, scope.row, 3)">停用</el-button>
              </el-space>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
// import BtnGroup from '../../components/BtnGroup'
import { getScorePageList, updateScoreState } from '@/api/url'
import {getFormData, postFormData} from '@/api/api'
import Dialog from "@/assets/js/dialog";
import ScoreManageDialog from "./components/ScoreManageDialog";
import DatePickerRange from "@/components/DatePickerRange";

export default {
  name: "TagManage",
  components: { DatePickerRange },
  data() {
    return {

      sexArray: [
        {label: '不限', value: -1},
        {label: '男', value: 1},
        {label: '女', value: 2},
      ],
      sex: -1,


      stateArray: [
        {label: '不限', value: -1},
        {label: '待启用', value: 1},
        {label: '已启用', value: 2},
        {label: '已停用', value: 3},
      ],
      state: 2,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //刷新组
      colList: ['创建时间', '性别', '分数', '评语', '状态', '操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      searchLoading: false,
      listLoading: false,

    }
  },
  methods: {

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },

    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.sex = -1;
      this.state = 2;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['state'] = this.state;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getScorePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    editScoreDialog(idx, row) {
      let _title = '';
      let scoreForm = {}
      if (idx > -1) {
        _title = '编辑评分'
        scoreForm = Object.assign({}, row);
      }else {
        _title = '新建评分'
      }
      Dialog.open({
        title: _title,
        component: ScoreManageDialog,
        data: {
          scoreForm: scoreForm,
          ids: idx,
          width: '500px'
        },
        confirm: (result) => {
            row['sex'] = result.sex
            row['score'] = result.score
            row['msg'] = result.msg
        }
      })
    },

    updateState(idx, row, state) {
      this.pageDataList[idx]['updateLoading'] = true;
      let param = {};
      param['id'] = row.id;
      param['state'] = state;
      postFormData(updateScoreState, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          // this.getPage()
          row.state = state
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.pageDataList[idx]['updateLoading'] = false;
      }).catch(()=> {
        this.pageDataList[idx]['updateLoading'] = false;
      })
    }


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
